'use client';

import React from 'react';
import Link from 'next/link';

const serviceLinks = [
  { href: '/services/mixing-mastering', label: 'Mixing & Mastering' },
  { href: '/services/session-drumming', label: 'Session Drumming' },
  { href: '/services/post-production', label: 'Post Production' },
];

const quickLinks = [
  { href: '/', label: 'Home' },
  { href: '/about', label: 'About' },
  { href: '/music', label: 'Music' },
  { href: '/shop', label: 'Shop' },
  { href: '/gallery', label: 'Gallery' },
  { href: '/courses', label: 'Courses' },
  { href: '/contact', label: 'Contact' },
];

export default function Footer() {
  const year = 2026;
  return (
    <footer
      style={{ background: '#000000', borderTop: '2px solid #ff1a1a', paddingBottom: '48px' }}
    >
      <div style={{ maxWidth: '1280px', margin: '0 auto', padding: '40px 24px 0' }}>
        <div
          style={{
            display: 'grid',
            gridTemplateColumns: 'repeat(auto-fit, minmax(200px, 1fr))',
            gap: '32px',
            marginBottom: '32px',
          }}
        >
          {/* Brand */}
          <div>
            <Link
              href="/"
              style={{ textDecoration: 'none', display: 'block', marginBottom: '12px' }}
            >
              <span
                style={{
                  fontFamily: 'Manrope, sans-serif',
                  fontWeight: 900,
                  fontSize: '1.1rem',
                  letterSpacing: '0.1em',
                  textTransform: 'uppercase',
                  color: '#ffffff',
                  textShadow: '0 0 8px rgba(255,26,26,0.7)',
                }}
              >
                DIGGITY GLOVER
              </span>
            </Link>
            <p
              style={{
                fontFamily: '"JetBrains Mono", monospace',
                color: '#cccccc',
                fontSize: '0.8rem',
                lineHeight: '1.6',
                marginBottom: '16px',
              }}
            >
              Metal Mixing Engineer · Session Drummer
            </p>
            {/* Social */}
            <div style={{ display: 'flex', flexWrap: 'wrap', gap: '12px' }}>
              {[
                { href: 'https://www.instagram.com/diggity.glover/', label: 'Instagram' },
                { href: 'https://www.tiktok.com/@diggity.glover', label: 'TikTok' },
                { href: 'https://www.youtube.com/@Diggity.Glover', label: 'YouTube' },
                {
                  href: 'https://www.facebook.com/profile.php?id=100081772446953',
                  label: 'Facebook',
                },
              ].map((s) => (
                <a
                  key={s.label}
                  href={s.href}
                  target="_blank"
                  rel="noopener noreferrer"
                  style={{
                    fontFamily: '"JetBrains Mono", monospace',
                    fontSize: '0.7rem',
                    letterSpacing: '0.1em',
                    textTransform: 'uppercase',
                    color: '#ff1a1a',
                    textDecoration: 'none',
                    transition: 'text-shadow 0.2s',
                  }}
                  onMouseEnter={(e) =>
                    (e.currentTarget.style.textShadow = '0 0 8px rgba(255,26,26,0.8)')
                  }
                  onMouseLeave={(e) => (e.currentTarget.style.textShadow = 'none')}
                >
                  {s.label}
                </a>
              ))}
            </div>
          </div>

          {/* Quick Links */}
          <div>
            <div
              style={{
                background: '#ff1a1a',
                color: '#000000',
                fontFamily: 'Manrope, sans-serif',
                fontWeight: 700,
                fontSize: '0.75rem',
                letterSpacing: '0.12em',
                textTransform: 'uppercase',
                padding: '5px 10px',
                marginBottom: '12px',
              }}
            >
              Quick Links
            </div>
            <nav style={{ display: 'flex', flexDirection: 'column', gap: '6px' }}>
              {quickLinks.map((link) => (
                <Link
                  key={link.label}
                  href={link.href}
                  style={{
                    color: '#cccccc',
                    textDecoration: 'none',
                    fontFamily: 'Manrope, sans-serif',
                    fontSize: '0.95rem',
                    transition: 'color 0.2s',
                  }}
                  onMouseEnter={(e) => {
                    (e.currentTarget as HTMLElement).style.color = '#ff1a1a';
                  }}
                  onMouseLeave={(e) => {
                    (e.currentTarget as HTMLElement).style.color = '#cccccc';
                  }}
                >
                  {link.label}
                </Link>
              ))}
            </nav>
          </div>

          {/* Services */}
          <div>
            <div
              style={{
                background: '#ff1a1a',
                color: '#000000',
                fontFamily: 'Manrope, sans-serif',
                fontWeight: 700,
                fontSize: '0.75rem',
                letterSpacing: '0.12em',
                textTransform: 'uppercase',
                padding: '5px 10px',
                marginBottom: '12px',
              }}
            >
              Services
            </div>
            <nav style={{ display: 'flex', flexDirection: 'column', gap: '6px' }}>
              {serviceLinks.map((link) => (
                <Link
                  key={link.label}
                  href={link.href}
                  style={{
                    color: '#cccccc',
                    textDecoration: 'none',
                    fontFamily: 'Manrope, sans-serif',
                    fontSize: '0.95rem',
                    transition: 'color 0.2s',
                  }}
                  onMouseEnter={(e) => {
                    (e.currentTarget as HTMLElement).style.color = '#ff1a1a';
                  }}
                  onMouseLeave={(e) => {
                    (e.currentTarget as HTMLElement).style.color = '#cccccc';
                  }}
                >
                  {link.label}
                </Link>
              ))}
            </nav>
          </div>
        </div>

        {/* Divider */}
        <div style={{ borderTop: '1px solid #ff1a1a', marginBottom: '3px' }} />
        <div style={{ borderTop: '1px solid #ff1a1a', marginBottom: '16px' }} />

        {/* Bottom */}
        <div
          style={{
            display: 'flex',
            flexDirection: 'column',
            gap: '6px',
            alignItems: 'center',
            textAlign: 'center',
          }}
        >
          <p
            style={{
              fontFamily: '"JetBrains Mono", monospace',
              fontSize: '0.75rem',
              color: '#666666',
              letterSpacing: '0.08em',
            }}
          >
            DIGGITY GLOVER © {year} — ALL RIGHTS RESERVED.
          </p>
          <p
            style={{
              fontFamily: '"JetBrains Mono", monospace',
              fontSize: '0.7rem',
              color: '#444444',
              letterSpacing: '0.06em',
            }}
          >
            Metal Mixing · Session Drumming · Metalcore & Deathcore
          </p>
          <Link
            href="/privacy"
            style={{
              fontFamily: '"JetBrains Mono", monospace',
              fontSize: '0.7rem',
              color: '#666666',
              letterSpacing: '0.08em',
              textDecoration: 'none',
              marginTop: '4px',
            }}
          >
            Privacy Policy
          </Link>
        </div>
      </div>
    </footer>
  );
}
